import { connect } from 'react-redux';
import React from 'react';

import { getClientInfo } from '@selectors/client';

import StepProductionPlanning from '../../../CreateProductModal/components/StepProductionPlanning';

const ConfigureProductionPlanningModal = (props) => {
  const {
    client: { hasMultipleServices },
    configureProductionData,
    setConfigureProductionData,
    params,
    selectStoresData,
  } = props;

  const productionParameters = {
    price: configureProductionData.price,
    currency: configureProductionData.currency,
    launchDate: configureProductionData.launchDate,
    endDate: configureProductionData.endDate,
    hasStock: configureProductionData.hasStock,
  };

  const storesProduct = (selectStoresData || []).filter((store) => store.isRowSelected);

  return (
    <StepProductionPlanning
      hasMultipleServices={hasMultipleServices}
      params={params}
      productionParameters={productionParameters}
      setProductionParameters={setConfigureProductionData}
      storesProduct={storesProduct}
    />
  );
};

const mapStateToProps = (state) => ({
  client: getClientInfo(state.baseReducer.user),
});

export default connect(mapStateToProps)(ConfigureProductionPlanningModal);
